import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import './styles.scss'

import moreInfo from './assets/more_info.svg'
import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'
import Switcher from '../../../../components/switcher'

import ComplectItem from "./complect_item"
import axios from 'axios';

export const postFxJSONBody = async (url: string): Promise<string> => {
  const result = await axios(url);
  return result ? JSON.stringify(result.data) : '';
};


class Busket extends Component<ReturnType<typeof storesToProps>> {

  public state = { isOpen: false, isOpenEntr: false, discount: 0}

  public componentDidMount() {
    const price = this.props.busket.allPrice
    if (50000 <= price && price < 100000) {
      this.setState({ discount: 5 })
    }
    if (100000 <= price && price < 150000) {
      this.setState({ discount: 7 })
    }
    if (150000 <= price && price < 200000) {
      this.setState({ discount: 10 })
    }
    if (200000 <= price && price < 250000) {
      this.setState({ discount: 12 })
    }
    if (250000 <= price && price < 500000) {
      this.setState({ discount: 15 })
    }
    if (500000 <= price && price < 1000000) {
      this.setState({ discount: 20 })
    }
    if (1000000 <= price) {
      this.setState({ discount: 25 })
    }
    return this.state.discount
  }
  public componentWillUpdate() {
    const price = this.props.busket.allPrice
    if (50000 <= price && price < 100000 && this.state.discount !== 5) {
      this.setState({ discount: 5 })
    }
    if (100000 <= price && price < 150000 && this.state.discount !== 7) {
      this.setState({ discount: 7 })
    }
    if (150000 <= price && price < 200000 && this.state.discount !== 10) {
      this.setState({ discount: 10 })
    }
    if (200000 <= price && price < 250000 && this.state.discount !== 12) {
      this.setState({ discount: 12 })
    }
    if (250000 <= price && price < 500000 && this.state.discount !== 15) {
      this.setState({ discount: 15 })
    }
    if (500000 <= price && price < 1000000 && this.state.discount !== 20) {
      this.setState({ discount: 20 })
    }
    if (1000000 <= price && this.state.discount !== 25) {
      this.setState({ discount: 25 })
    }

  }

  public onOpenEntrHundler = (e: any) => {
    e.stopPropagation()
    this.setState({ isOpenEntr: !this.state.isOpen })
  }

  public onChangeIsOpenHundler = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }


  public routeChange = () => {

    document.location.href = `/personal/order/make/`; 
  }

  public render() {
    const { 
      getProdictsCount, 
      allPrice, 
      getGoods, 
      removeProduct, 
      entrsPlates, 
      removeEntrPlates, 
      removeAll,
      addLogo,
      swithAddLogo
     } = this.props.busket
    const { housePlates } = this.props.configuratorStore
    const { getCountsOfFlats, activeEntrance, fullPrice } = housePlates
    let result = new Date();
    result.setDate(result.getDate() + 5);

    return (
      <div className="backet_container-full">
          <div className="opened_busket-full">
            <div className="busket-full">
              <div className="basket-line-full" >


                {/* <transition name="basket-over"> */}
                <div className="basket-line-body-full" id="basket-line-body" ref="basket-line-body" v-show="isVisible">
                  <div className="basket-line-body__inset-full">
                    <div className="basket-line-body__title-full">Корзина</div>

                    <div className="basket-line-body__items-full">
                      <div className="scroll-area">
                        <div className="basket-line-body__items-wrapper">

                          {entrsPlates.length > 0 && <div className="complect">
                            <div className={`complect__group${this.state.isOpenEntr ? '__active' : ""}`} onClick={this.onOpenEntrHundler}>
                              <div className="complect__group__name">
                                <span>Комплект внутриподъездных табличек на дом</span>
                                <div className="complect__close" onClick={removeAll}>
                                  <img src="/local/templates/sign_plus/images/close.svg" />
                                </div>
                              </div>

                              {this.props.configuratorStore.housePlates.Entrances.map((item, index) =>
                                <ComplectItem key={index} entrNumber={index} entrPrice={item.priceEntrance} />)}
                              <div className="complect__group__summ">
                                <span>450000 руб.</span>
                              </div>
                            </div>
                          </div>}
                          {getGoods.map(item =>
                            <div className="custom_items_div" id={item.id}>
                              <ul className="complect__items">
                                <li className="complect__item">
                                  <div className="complect__item__dopinfo">
                                    <div className="complect__item__img">
                                      <img className="image" src={item.img as string} />
                                      <span>{item.size} см.</span>
                                    </div>
                                    <div className="complect__item__dopinfo">
                                      <div className="complect__item__name">{item.name}</div>
                                      <div className="complect__item__val">{ item.description}</div>
                                    </div>
                                    <div className="complect__item__close">
                                      <img src="/local/templates/sign_plus/images/close.svg" onClick={() => removeProduct(item.randId)} />
                                    </div>
                                  </div>
                                  <div className="complect__item__summdiv">
                                    <div className="complect__item__price">{item.price} руб/шт</div>
                                    <div className="complect__item__quant">{item.count} шт</div>
                                    <div className="complect__item__summ">{item.count * item.price} руб.</div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="basket-line-body__footer">
                      <div className="basket-line-body__footer-list">
                        <dl className="basket-line-body__footer-item basket-line-body__footer-item--quantity">
                          <dt>Всего наименований</dt>
                          <dd>{getGoods.length}</dd>
                        </dl>
                        <dl className="basket-line-body__footer-item basket-line-body__footer-item--done-date">
                          <dt>Готовность</dt>
                          <dd v-if="!priceUpdateLoading">{result.toLocaleDateString('ru')}</dd>
                        </dl>
                        <dl className="basket-line-body__footer-item basket-line-body__footer-item--total_withiout_discont">
                          <dt>Итого без скидки</dt>
                          <dd v-if="!priceUpdateLoading">{allPrice} руб</dd>
                        </dl>
                        <dl className="basket-line-body__footer-item basket-line-body__footer-item--total_discont">
                          <dt>Скидка</dt>
                          <dd v-if="!priceUpdateLoading">{this.state.discount}%</dd>
                        </dl>
                        <dl className="basket-line-body__footer-item basket-line-body__footer-item--total">
                          <dt>Итого к оплате</dt>
                          <dd v-if="!priceUpdateLoading">{ this.state.discount === 0 ?  allPrice : (allPrice - Math.round(allPrice * this.state.discount / 100)) } руб</dd>
                        </dl>
                      </div>
                      <div className="add-logo">
                        <div className="text">Добавить логотип</div>
                        {addLogo && <div className="descriptions">Мы свяжемся с вами для согласования деталей после офрмления заказа</div>}
                        <Switcher checked={addLogo} onClick={swithAddLogo} />
                      </div>
                      <div className="basket-line-body__controls">
                        <form method={"POST"} action="/personal/order/make/">
                            <input name="P_REKLAMA_BUSKET"  value={localStorage.getItem("busket") as any}/>
                            <input name="P_REKLAMA_ADD_LOGO"  value={addLogo as any}/>
                            <button className="button button--primary" type="submit">Заказать</button>
                        </form>
                      </div>
                      <div className="basket-line-body__controls2">
                        <a v-tooltip="'Печать'" href={'javascript:(print());'}>
                          <svg viewBox="0 0 29.2 24.4" width="29.2" height="24.4"><path fill="none" stroke="#222a32" stroke-linejoin="round" d="M3.2 5.7L4.7.5h19.8l1.4 5.2M4.6 14.9h19.9l1.5 9H3.1z"></path><path fill="none" stroke="#222a32" stroke-linecap="round" stroke-miterlimit="22.93" d="M23.1 9.3h2.8"></path><path fill="none" stroke="#222a32" stroke-linejoin="round" d="M.5 5.6v13.8h3.3l.8-4.5h19.9l.8 4.5h3.4V5.6z"></path><path fill="none" stroke="#222a32" stroke-linecap="round" stroke-miterlimit="22.93" d="M8 21h13.5"></path>
                          </svg>
                        </a>
                        <span className="basket-line-body__controls2-spliter"></span>
                        <a className="modal-trigger-email" v-tooltip="'Отправить список'">
                          <svg viewBox="0 0 31.1 21" width="31.1" height="21"><g fill="none" stroke="#222a32"><path stroke-miterlimit="22.93" d="M1.9.5h27.4c.8 0 1.4.6 1.4 1.4v17.3c0 .8-.6 1.4-1.4 1.4H1.9c-.8 0-1.4-.6-1.4-1.4V1.9c0-.8.6-1.4 1.4-1.4z"></path><path stroke-linejoin="round" d="M19.2 10.2l10.9 9.1m-29 0L12 10.2M1.1.8l11.4 9.6c2.8 2.4 3.3 2.4 6.2 0L30.1.8"></path></g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div >
            </div >
          </div >
        
      </div>
    )


  }
}


const storesToProps = ({ store }: IStoresMap) => ({
  busket: store.BusketStore,
  configuratorStore: store.configuratorStore,
})

export default connector(storesToProps)(Busket)